import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSwap20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArrowSwap20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.47 8.56a.75.75 0 0 0 1.06 1.06l2.83-2.828.53-.53-.53-.53-2.83-2.829a.75.75 0 1 0-1.06 1.06L16.007 5.5H2A.75.75 0 1 0 2 7h14.03zM4 13h-.02l1.55-1.55a.75.75 0 0 0-1.06-1.06l-2.828 2.83-.53.53.53.53 2.828 2.829a.75.75 0 0 0 1.06-1.061L3.985 14.5H18a.75.75 0 0 0 0-1.5zm-.767.749.018-.018v.036z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSwap20);
